/* Shared filter/sort types for the employee Filter & Sort popovers.
   Used by the People directory and the Who's away calendar. */

/** Sort fields the server understands (sent as query params). */
export type ServerSortField = 'first_name' | 'last_name' | 'hire_date'

/** All sort fields (server + client-only like leave_type). */
export type EmployeeSortField = ServerSortField | 'leave_type'

export interface SortState {
    field: EmployeeSortField
    dir: 'asc' | 'desc'
}

export interface PeopleFilters {
    companyId?: number
    teamId?: number
    locationId?: number
    countryCode?: string
    managerId?: number
}

export interface FilterOption {
    value: string
    label: string
}

export interface FilterOptions {
    companies: FilterOption[]
    teams: FilterOption[]
    locations: FilterOption[]
    countries: FilterOption[]
    managers: FilterOption[]
}

/** Count of active (set) filter dimensions — drives the Filter button badge. */
export const countActiveFilters = (f: PeopleFilters): number =>
    [f.companyId, f.teamId, f.locationId, f.countryCode, f.managerId].filter(
        (v) => v !== undefined && v !== '',
    ).length

/**
 * Parse a URL query string (e.g. `window.location.search`) into PeopleFilters.
 * Numeric dimensions accept only valid numbers (empty / non-numeric are
 * dropped); string dimensions accept any non-empty value. Unknown params are
 * ignored. Lets a link like `/calendar?teamId=42` land pre-filtered.
 */
export const parsePeopleFiltersFromSearch = (search: string): PeopleFilters => {
    const params = new URLSearchParams(search)
    const out: PeopleFilters = {}
    for (const key of ['companyId', 'teamId', 'locationId', 'managerId'] as const) {
        const raw = params.get(key)
        if (raw && !Number.isNaN(Number(raw))) out[key] = Number(raw)
    }
    const countryCode = params.get('countryCode')
    if (countryCode) out.countryCode = countryCode
    return out
}
